import { MonitorIcon, MoonIcon, SunIcon } from 'lucide-react';

export const THEME_STORAGE_KEY = 'theme' as const;

export const THEME_CONFIG = [
  {
    key: 'system',
    labelKey: 'userMenu.themes.system',
    icon: MonitorIcon,
  },
  {
    key: 'light',
    labelKey: 'userMenu.themes.light',
    icon: SunIcon,
  },
  {
    key: 'dark',
    labelKey: 'userMenu.themes.dark',
    icon: MoonIcon,
  },
] as const;

export type Theme = (typeof THEME_CONFIG)[number]['key'];
